import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'utils/modifiedTranslation';
import { useIsMobileResolution } from 'utils/hooks/useIsMobileResolution';
import { MONTH_PICKER } from 'modules/questionnaire/questionTypes';
import { useStyles } from './answersListStyles';
import { DeleteConfirmationDialog } from './DeleteConfirmationDialog';

export const CompoundQuestionAnswer = ({
  subQuestions,
  subQuestionsAnswers = {},
  handleEdit,
  handleRemove,
}) => {
  const [isDeleteConfirmationDialogOpen, setIsDeleteConfirmationDialogOpen] = React.useState(false);
  const classes = useStyles();
  const { t } = useTranslation();

  const isMobile = useIsMobileResolution();

  return (
    <div className={classes.root}>
      <ul className={classes.subQuestionList}>
        {subQuestions.map(({ id: subQuestionId, type }) => {
          const value = subQuestionsAnswers[subQuestionId];

          if (!value) {
            return null;
          }

          let label = null;

          if (type === MONTH_PICKER) {
            if (typeof value !== 'object') {
              return null;
            }
            const year = value.year[0].value;
            const month = value.month[0].value + 1;
            label = `Received last ${`0${month}`.slice(-2)}/${year}`;
          } else if (Array.isArray(value)) {
            label = value.map((item) => item && typeof item === 'object' && item.label && t(item.label)).join(', ');
          } else if (typeof value === 'object' && value.label) {
            label = t(value.label);
          }

          return (
            <li key={subQuestionId} className={classes.subQuestion}>
              {label}
            </li>
          );
        })}
      </ul>
      <div className={classes.actionBtnGroup}>
        <Button
          variant="text"
          className={classes.button}
          onClick={() => setIsDeleteConfirmationDialogOpen(true)}
        >
          {t('questionnaire.compound_question_answer.delete')}
        </Button>
        <Button variant="text" className={classes.button} onClick={handleEdit}>
          {t('questionnaire.compound_question_answer.edit')}
        </Button>
      </div>
      <DeleteConfirmationDialog
        closeDialog={() => setIsDeleteConfirmationDialogOpen(false)}
        isOpen={isDeleteConfirmationDialogOpen}
        confirm={() => {
          setIsDeleteConfirmationDialogOpen(false);
          handleRemove();
        }}
        isFullScreen={isMobile}
        message={t('questionnaire.compound_question_answer.are_you_sure')}
      />
    </div>
  );
};

CompoundQuestionAnswer.propTypes = {
  subQuestions: PropTypes.arrayOf(PropTypes.object).isRequired,
  subQuestionsAnswers: PropTypes.object,
  handleEdit: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
};
